<template>
	<Dialog
		max-width="600"
		content-height="50"
		title="Add a new project"
		:show="show"
		@close="close"
	>
		<template slot="content">
			<v-text-field
				v-model="project.name"
				:error-messages="project.errors.name"
				:disabled="project.saving"
				name="Name"
				label="Project Name"
			/>
		</template>
		<template slot="buttons">
			<v-btn
				flat
				color="success"
				:disabled="disabledButtons"
				:loading="project.saving"
				@click="create()"
			>
				Create
			</v-btn>
			<v-btn
				flat
				color="success"
				:disabled="disabledButtons"
				:loading="project.saving"
				@click="create(true)"
			>
				Create and Open
			</v-btn>
		</template>
	</Dialog>
</template>

<script>
import { sync } from 'vuex-pathify';
import Dialog from '@/components/Global/Dialog';
import { Project } from '@/models/Project';

export default {
	components: {
		Dialog,
	},
	data() {
		return {
			show: false,
			project: new Project(),
		}
	},
	computed: {
		disabledButtons() {
			// Disable buttons on init with hasChanged
			const hasChanged = !!this.project.changed(); // .changed() returns false or array of changed attributes
			return !hasChanged || this.project.hasErrors() || this.project.saving;
		},
		projects: sync('projects/active'),
	},
	methods: {
		create(redirect = false) {
			this.project.save().then(() => {
				const project = this.project.clone();
				
				this.projects.add(project);
				this.$store.dispatch('projects/addToRecentProjects', project.id);
				this.$notify('success', `Project "${project.name}" created successfully.`);
				this.close();
				
				if (redirect) {
					this.$router.push({ name: 'ReportsList', params: { projectId: project.id } });
				}
			}).catch((e) => {
				dump('Error creating project', e);
				this.$notify('error', 'Failed to create a new project.');
			});
		},
		close() {
			this.show = false;
			this.project.clear();
		},
	},
}
</script>
